export enum QUOTE_UPDATE_TYPE {
  DPR = 'dpr',
  QUOTE = 'quote',
  INDEX = 'index',
  DEPTH = 'depth',
  LTPClose = 'LtpAndClosePrice',
  GainerLoser = 'GainerLoser',
  StrikePrice = 'StrikePrice',
  OPEN_INTEREST = 'OpenInterest',
  OHLC = 'OHLC',
  Delta = 'Delta',
  THROTTLER_LTP = 'THROTTLER_LTP',
  FIFTY_DEPTH = 'FIFTY_DEPTH',
  UPDATED_THROTTLER_LTP = 'UPDATED_THROTTLER_LTP', // This is for marketId and securityId
}

export enum SYMBOL_SUBSCRIPTION_TYPE {
  SUBSCRIBED,
  UNSUBSCRIBED,
  FIRST_FETCH_SUBSCRIPTION,
  MAX
};

export enum SOCKET_MSG_TYPES {
  FIRST_FETCH = 0,
  SECURITY_ID_MAPPING = 1,
  SECURITY_ID_MAPPING_COMPLETED = 2,
  SESSION_MESSAGES = 3,
  SYMBOL_SESSION_INFO = 4,
  OHLC_DATA = 5,
  OHLC_DATA_COMPLETED = 6,
  SNAPSHOT_DATA = 7,
  SNAPSHOT_DATA_COMPLETED = 8,
  QUOTE = 9,
  SESSION_CHANGE = 10,
  NOTICE = 11,
  INDEX_VALUE = 12,
  OPEN_INTEREST = 13,
  AUCTION_UPDATE = 14,
  AGGREGATE_QUOTE = 15,
  MARKET_STATUS = 16,
  DAILY_PRICE_RANGE = 17,
  TRADE_EXECUTION_RANGE = 18,
  SYMBOL_MARKET_INFO = 19,
  TOP_DEPTH_QUOTE = 20,
  TBT_DATA = 21,
  TRIMMED_QUOTE = 22,
  INDEX_UNDERLYINGS = 23,
  MOST_ACTIVE = 24,
  TOP_GAINERS_LOSERS = 25,
  GROUP_QUOTE = 26,
  Login_Response = 27,
  LTP_Close_PRICE = 28,
  STRIKE_PRICE = 29,
  DELTA = 31,
  FIFTY_DEPTH = 37
}

export enum HeartBeat {
  Heart_Beat = 1
}

export enum BookStream {
  ORDERS = "orders"
}

export enum SubjectType {
  ORDERS = 'orders',
  TRADES = 'trades',
  POSITIONS = 'positions',
  ALERTS = 'alerts',
  BACKTEST = 'backtest',
  STRATEGY = 'strategy',
  TERMINATE = 'terminate',
  SYMBOLADDED = 'symbolAdded',
  SYMBOLPOSITIONUPDATED = 'symbolPositionUpdated',
  SYMBOLDELETED = 'symbolDeleted',
  LISTALGOS = 'listAlgos',
  STATUS = 'status',
  BROKER = 'broker',
  SUBSCRIPTION = 'subscription',
  TRANSACTIONS = 'transactions',
  MARGINBUCKET = 'marginBucket',
  manualSquareOff = 'squareOff',
  INFRASTATUS = 'infraStatus',
  GLOBALEXIT = 'globalExit',
  NOTIFICATIONS = 'notifications',
  AUTODEPLOYMENT = 'autoDeployment',
  AI_ASSISTANT = 'aiAssistant',
  ACCOUNT_USAGE = 'accountUsage',
  CHAT_NOTIFICATION = 'notification',
  OPERATOR_CLIENT_STRATEGY = 'operatorClientStrategy',
  CLIENT_MTM_UPDATE = 'clientMTMUpdate',
  BROKER_CONNECTION_UPDATE = 'brokerConnectionUpdate',
  BROKER_LOGIN_UPDATE = 'brokerLoginUpdate',
  BROKER_CREDENTIALS_UPDATE = 'brokerCredentialUpdate',
  BROKER_CONNECTION_SNAPSHOT = 'brokerConnectionSnapshot',
  AUTH = 'auth'
}

export enum FirstFetchDataType {
  First_Fetch_Data_DPR = 1,
  First_Fetch_Data_QUOTE = 2,
  First_Fetch_Data_OI = 4,
  First_Fetch_Data_INDEX = 8,
  First_Fetch_Data_52_WEEK_HIGH_LOW = 16,
  First_Fetch_Data_CLOSE_PRICE = 32,
  First_Fetch_Data_TER = 64,
  First_Fetch_Data_LTP_CLOSE_PRICE_ONLY = 128
}

export enum DepthFetchCount{
  FIVE = 5,
  FIFTY = 50,
}

/** Application-defined WebSocket close codes (RFC 6455: 4000–4999). */
export const WS_APP_CLOSE_CODES = {
  AUTH_FAILURE: 4001,
  HEARTBEAT_FAILED: 4002,
} as const;

export const WS_CLOSE_CODES: Record<number, string> = {
  1000: 'normal_closure',
  1001: 'going_away',
  1002: 'protocol_error',
  1003: 'unsupported_data',
  1005: 'no_status_received',
  1006: 'abnormal_closure',
  1007: 'invalid_frame_payload',
  1008: 'policy_violation',
  1009: 'message_too_big',
  1010: 'mandatory_extension',
  1011: 'internal_server_error',
  1012: 'service_restart',
  1013: 'try_again_later',
  1014: 'bad_gateway',
  1015: 'tls_handshake_failed',
  [WS_APP_CLOSE_CODES.AUTH_FAILURE]: 'auth_failure',
  [WS_APP_CLOSE_CODES.HEARTBEAT_FAILED]: 'heartbeat_request_failed',
};

export enum SocketType {
  ORDER_DATA_SOCKET = 'orderDataSocket',
  UTRADE_AI_SOCKET = 'uTradeAiSocket',
  MARKET_DATA_SOCKET = 'marketDataSocket',
}